import { Toast } from "vant";
import Vue from "vue";
export const mixins = {
  date() {
    return {
      renewal: false,
      tabTextColor: "",
      timeSetInterval: null
    };
  },
  mounted() { },
  created() { },
  watch: {
  },
  methods: {
  },
};
